var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"morda-lenta container"},[_c('div',{staticClass:"morda-lenta-overlay"}),_vm._v(" "),(_vm.loader)?_c('div',{staticClass:"morda-lenta-loader"},[_vm._v("\n    "+_vm._s(_vm.$t("loading.loading"))+"\n  ")]):(!_vm.mordaLentaIsEmpty('mordaLenta'))?_c('ul',{staticClass:"morda-lenta-list",class:[
      { 'morda-lenta-animate': _vm.animate },
      'comb-end' + _vm.combEnd,
      'comb-length' + _vm.combLength,
    ]},_vm._l((_vm.mordaLentaLocal),function(card,index){return _c('li',{key:index,class:[
        {
          'morda-lenta-card': card.rank,
          'morda-lenta-comb-wrapper': !card.rank,
          'first-card': card.rank && index == 0,
          'last-card': card.rank && index == _vm.mordaLentaLocal.length - 1,
        },
        'index' + (parseInt(index) + 1),
        'throughIndex' + card.throughIndex,
        'length' + card.length,
        'morda-lenta-item',
      ]},[(card.rank)?_c('MordaLentaCard',{attrs:{"card":card}}):_c('ul',{staticClass:"morda-lenta-combination"},_vm._l((card),function(cardInner,indexInner){return _c('li',{key:indexInner,staticClass:"morda-lenta-card morda-lenta-card-inner",class:[
            {
              'morda-lenta-card': card.rank,
              'first-card': index == 0 && indexInner == 0,
              'last-card':
                index == _vm.mordaLentaLocal.length - 1 &&
                indexInner == card.length - 1,
            },
            'throughIndex' + cardInner.throughIndex,
          ]},[_c('MordaLentaCard',{attrs:{"card":cardInner}})],1)}),0)],1)}),0):_c('p',[_vm._v(_vm._s(_vm.$t("mordaLenta.noPhoto")))]),_vm._v(" "),_c('div',{staticClass:"morda-lenta-button"},[_c('mordaLentaButtonFund')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }